export default {
  activate: "Ativar",
  activate_registration_title: "Confirmação de Ativação",
  activate_registration_description:
    "Você está prestes a ativar o registro selecionado. Ao fazer isso, o registro será habilitado para processar dados e realizar ações específicas.",

  disable: "Desativar",
  disable_registration_title: "Confirmação de Desativação",
  disable_registration_description:
    "Você está prestes a desativar o registro selecionado. Ao fazer isso, o registro será desabilitado e deixará de executar suas funcionalidades.",

  delete: "Deletar",
  delete_registration_title: "Confirmação de Exclusão",
  delete_registration_description:
    "Você está prestes a excluir o modelo selecionado. Ao fazer isso, o modelo será removido permanentemente do sistema. ",
};
